import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import TagManager from 'react-gtm-module';

import CopyRight from '@/components/GlobalMenu/CopyRight';
import Placeholder from '@/components/Placeholder';
import { generateKey } from '@/utils';

import SearchBar from '../SearchBar';
import SearchResult from './SearchResult';
import { contentTypeToSlug } from '../../../pages/RangePage/rangeNameConverter';

import {
  Wrapper,
  DropdownInner,
  Listing,
  Category,
  CategoryTitle,
  CategoryLinks,
  Subcategory,
  SubcategoryTitle,
  ItemTitle,
  CopyRightWrapper,
  PlaceholderWrapper,
  PlaceholderColumn,
  Hr,
} from './Dropdown.style';

/**
 * 商品情報メニュー (PC 版 ヘッダー / フッター共用コンポーネント)
 */
class Dropdown extends React.Component {
  state = {
    mouseOver: false,
    searchResult: undefined,
  };

  setResult = searchResult => {
    this.setState({ searchResult });
  };

  enterDropdown = () => {
    this.setState({ mouseOver: true });
  };

  leaveDropdown = () => {
    this.setState({ mouseOver: false });
  };

  // Placeholder 表示に使用する
  placeholderStart = 1;
  placeholderEnd = 5;

  gtmClickHeader = clickurl => {
    if (this.props.isFooterMenu) return;
    TagManager.dataLayer({
      dataLayer: {
        event: 'clickheader',
        clickurl,
      },
    });
  };

  render() {
    const { mouseOver, searchResult } = this.state;
    const { locale, open, top, isFooterMenu, footerCopyright, menuItem } = this.props;

    return (
      <Wrapper
        open={open}
        top={top}
        className={isFooterMenu ? 'footerMenu' : null}
        onMouseEnter={this.enterDropdown}
        onMouseLeave={this.leaveDropdown}
      >
        <DropdownInner open={open || mouseOver} className={isFooterMenu ? 'footerMenu' : null}>
          {!isFooterMenu && <SearchBar setResult={this.setResult} />}
          {searchResult ? (
            <SearchResult data={searchResult} />
          ) : (
            <Listing className={isFooterMenu ? 'footerMenu' : null}>
              {_.get(menuItem, 'children') &&
                menuItem.children.map(category => (
                  <Category key={category.entryId}>
                    {/* 各カテゴリ (例) HAIR CARE) */}
                    <CategoryTitle color={isFooterMenu ? '#fff' : '#333'}>{category.label}</CategoryTitle>
                    <CategoryLinks>
                      {category.children.map(
                        item =>
                          item.contentType === 'siteOptionsProductSubcategory' ? (
                            <Subcategory key={item.entryId}>
                              {/* 各サブカテゴリ (例) SUBLIMIC) */}
                              {item.url ? (
                                <Link
                                  to={`/${locale}${item.url}`}
                                  href={`/${locale}${item.url}`}
                                  onClick={() => this.gtmClickHeader(item.url)}
                                >
                                  <SubcategoryTitle underline color={isFooterMenu ? '#fff' : '#333'}>
                                    {item.label}
                                  </SubcategoryTitle>
                                </Link>
                              ) : (
                                <SubcategoryTitle color={isFooterMenu ? '#fff' : '#333'}>{item.label}</SubcategoryTitle>
                              )}
                              <CategoryLinks>
                                {item.children.map(range => (
                                  <ItemTitle key={range.entryId} color={isFooterMenu ? '#fff' : '#808080'}>
                                    <Link
                                      to={{
                                        pathname: `/${locale}/range/${contentTypeToSlug(range.contentType)}/${
                                          range.slug
                                        }`,
                                        state: {
                                          ancestor: category.label.toUpperCase(),
                                        },
                                      }}
                                      href={`/${locale}/range/${contentTypeToSlug(range.contentType)}/${range.slug}`}
                                      onClick={() =>
                                        this.gtmClickHeader(
                                          `/${locale}/range/${contentTypeToSlug(range.contentType)}/${range.slug}`
                                        )
                                      }
                                    >
                                      {range.name}
                                    </Link>
                                  </ItemTitle>
                                ))}
                              </CategoryLinks>
                            </Subcategory>
                          ) : (
                            <ItemTitle key={item.entryId} color={isFooterMenu ? '#fff' : '#808080'}>
                              {/* サブカテゴリを持たないもの (例) COLORMUSE) */}
                              <Link
                                to={{
                                  pathname: `/${locale}/range/${contentTypeToSlug(item.contentType)}/${item.slug}`,
                                  state: {
                                    ancestor: category.label.toUpperCase(),
                                  },
                                }}
                                href={`/${locale}/range/${contentTypeToSlug(item.contentType)}/${item.slug}`}
                                onClick={() =>
                                  this.gtmClickHeader(
                                    `/${locale}/range/${contentTypeToSlug(item.contentType)}/${item.slug}`
                                  )
                                }
                              >
                                {item.name}
                              </Link>
                            </ItemTitle>
                          )
                      )}
                    </CategoryLinks>
                  </Category>
                ))}
            </Listing>
          )}
          {/* Placeholder 表示部分 */}
          {!(menuItem && _.get(menuItem, 'children')) && (
            <PlaceholderWrapper>
              <PlaceholderColumn marginRight="35px">
                <Placeholder w="100%" h="35px" m="0 0 10px 0" />
                <Hr color="#4b4b4b" />
                {new Array(this.placeholderEnd - this.placeholderStart)
                  .fill(null)
                  .map((item, index) => (
                    <Placeholder w="150px" h="18px" m="10px 0 0 0" key={generateKey('placeholder-left-top', index)} />
                  ))}
                <Placeholder w="100%" h="35px" m="40px 0 10px 0" />
                <Hr color="#4b4b4b" />
                {new Array(this.placeholderEnd - this.placeholderStart)
                  .fill(null)
                  .map((item, index) => (
                    <Placeholder
                      w="150px"
                      h="18px"
                      m="10px 0 0 0"
                      key={generateKey('placeholder-left-bottom', index)}
                    />
                  ))}
              </PlaceholderColumn>
              <PlaceholderColumn marginRight="0">
                <Placeholder w="100%" h="35px" m="0 0 10px 0" />
                <Hr color="#4b4b4b" />
                {new Array(this.placeholderEnd - this.placeholderStart)
                  .fill(null)
                  .map((item, index) => (
                    <Placeholder w="150px" h="18px" m="10px 0 0 0" key={generateKey('placeholder-right-top', index)} />
                  ))}
                <Placeholder w="100%" h="35px" m="40px 0 10px 0" />
                <Hr color="#4b4b4b" />
                {new Array(this.placeholderEnd - this.placeholderStart)
                  .fill(null)
                  .map((item, index) => (
                    <Placeholder
                      w="150px"
                      h="18px"
                      m="10px 0 0 0"
                      key={generateKey('placeholder-right-bottom', index)}
                    />
                  ))}
              </PlaceholderColumn>
            </PlaceholderWrapper>
          )}
        </DropdownInner>
        {isFooterMenu && (
          <CopyRightWrapper>
            {!footerCopyright ? (
              <Placeholder w="220px" h="13px" m="60px 0 80px 80px" />
            ) : (
              <CopyRight footerCopyright={footerCopyright} />
            )}
          </CopyRightWrapper>
        )}
      </Wrapper>
    );
  }
}

Dropdown.defaultProps = {
  isFooterMenu: false,
  menuItem: [],
  footerCopyright: null,
};

Dropdown.propTypes = {
  locale: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  top: PropTypes.bool.isRequired,
  isFooterMenu: PropTypes.bool,
  menuItem: PropTypes.shape({}),
  // コピーライト表示内容
  footerCopyright: PropTypes.string,
};

const mapState = state => ({
  // コピーライト表示内容
  footerCopyright: state.siteOptions.footerCopyright,
});

export default connect(mapState)(Dropdown);



// WEBPACK FOOTER //
// ./src/components/GlobalMenu/Desktop/Dropdown.js